import { render, staticRenderFns } from "./NewRecursiveInput.vue?vue&type=template&id=98115d8c&scoped=true&"
import script from "./NewRecursiveInput.vue?vue&type=script&lang=js&"
export * from "./NewRecursiveInput.vue?vue&type=script&lang=js&"
import style0 from "./NewRecursiveInput.vue?vue&type=style&index=0&id=98115d8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98115d8c",
  null
  
)

export default component.exports